function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isEmpty, merge } from 'lodash';
export var resolveLocalityFromMap = (type, idOrSlug, localityMap) => {
  if (!idOrSlug) {
    return null;
  }
  if (!type) {
    var pointer = localityMap[idOrSlug];
    if (typeof pointer === 'string') {
      return resolveLocalityFromMap(pointer, idOrSlug, localityMap);
    }
    return null;
  }
  var typeMap = localityMap[type];
  if (!typeMap) {
    return null;
  }
  var value = typeMap[idOrSlug];
  if (!value) {
    return null;
  }
  if (typeof value === 'object') {
    return value;
  }
  return resolveLocalityFromMap(type, value, localityMap);
};
export var findMissing = (searchQuery, localityMap) => {
  var localities = searchQuery.getLocalities().map(_ref => {
    var id = _ref.id,
      slug = _ref.slug,
      type = _ref.type;
    return _objectSpread(_objectSpread(_objectSpread({}, id && {
      id
    }), slug && {
      slug
    }), {}, {
      type,
      includeParents: true
    });
  });
  return localities.filter(_ref2 => {
    var id = _ref2.id,
      type = _ref2.type,
      slug = _ref2.slug,
      includeParents = _ref2.includeParents;
    var cachedLocality = resolveLocalityFromMap(type, id || slug, localityMap);
    return !cachedLocality || includeParents && isEmpty(cachedLocality.parent) && cachedLocality.type !== 'REGION';
  });
};
export var resolveLocalities = function resolveLocalities(searchQuery, lookupService) {
  var localityMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var missing = findMissing(searchQuery, localityMap);
  return isEmpty(missing) ? Promise.resolve(localityMap) : lookupService(missing).then(result => merge({}, localityMap, result.reduce((map, each) => merge(map, _objectSpread({
    [each.type]: _objectSpread({
      [each.id]: each
    }, each.slug && each.type !== 'POSTCODE' && {
      [each.slug]: each.id
    })
  }, each.slug && {
    [each.slug]: each.type
  })), {})));
};